import type { ReactNode } from 'react';

export const symbol_android_cell_4_bar: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M60-210v-208q0-20.83 14.62-35.42Q89.24-468 110.12-468q20.88 0 35.38 14.58Q160-438.83 160-418v208q0 20.83-14.62 35.42Q130.76-160 109.88-160 89-160 74.5-174.58 60-189.17 60-210Zm247 0v-311q0-20.83 14.62-35.42Q336.24-571 357.12-571q20.88 0 35.38 14.58Q407-541.83 407-521v311q0 20.83-14.62 35.42Q377.76-160 356.88-160q-20.88 0-35.38-14.58Q307-189.17 307-210Zm246 0v-415q0-20.83 14.62-35.42Q582.24-675 603.12-675q20.88 0 35.38 14.58Q653-645.83 653-625v415q0 20.83-14.62 35.42Q623.76-160 602.88-160q-20.88 0-35.38-14.58Q553-189.17 553-210Zm247 0v-539q0-20.83 14.62-35.42Q829.24-799 850.12-799q20.88 0 35.38 14.58Q900-769.83 900-749v539q0 20.83-14.62 35.42Q870.76-160 849.88-160q-20.88 0-35.38-14.58Q800-189.17 800-210Z"
		/>
	</svg>
);
